import { R as n, T as s } from "./isClient-ec947a14.mjs";
const c = (r) => r.toLowerCase().replace(/-/g, "").replace(/^aria/, "aria-"), f = (r) => Object.fromEntries(Object.entries(r).map(([e, t]) => [c(e), t]));
function o(r, e) {
  const t = f(e), i = n[r] || n.region;
  return Object.fromEntries(Object.entries(t).filter(([a]) => i == null ? void 0 : i.includes(a)));
}
function l(r, e) {
  const t = s[r] || "region";
  return o(t, e);
}
function u(r, e) {
  return r in n ? o(r, e) : l(r, e);
}
export {
  l as a,
  u as b,
  o as g
};
